import { useState, useEffect } from 'react';

export const useVisitId = () => {
  const [visitId, setVisitId] = useState<string>('');
  let timeoutId;

  const getVisitId = (retryLimit: number) => {
    const libraryState = localStorage.getItem('library-state');

    if (libraryState) {
      const parsedLibraryState = JSON.parse(libraryState);
      setVisitId(parsedLibraryState?.model?.visit?.visitId);
    } else if (retryLimit > 0) {
      timeoutId = setTimeout(() => getVisitId(retryLimit - 1), 500);
    } else {
      console.log('Failed to fetch visit id.');
    }
  };

  useEffect(() => {
    getVisitId(10);

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  return visitId;
};
